import ApiService from '../services/ApiService';
import FileService from '../services/FileService';

export default class NewsletterRepository {
    constructor() {
        this.apiService = new ApiService();
        this.fileService = new FileService();
    }

    deleteNewsletter(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete(`newsletters/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getNewsletters(sort) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('newsletters?sort=' + sort)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}
